import React from "react";
import "./Quality.css";
import qualityImage from "../assets/images/quality.jpg";
import bioImage from "../assets/images/bioequivalent.jpg";
import ema from "../assets/logos/ema.png";
import fda from "../assets/logos/fda.png";
import gmp from "../assets/logos/gmp.png";
import edqm from "../assets/logos/edqm.png";
import gulf from "../assets/logos/gulf.png";
import anvisa from "../assets/logos/anvisa.png";
import healthCanada from "../assets/logos/health-canada.png";
import tga from "../assets/logos/tga.png";
import ministry from "../assets/logos/ministry.png";
import sahpra from "../assets/logos/sahpra.png"; // use your image

const QualityPage = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="quality-hero"
        style={{ backgroundImage: `url(${qualityImage})` }}
      >
        <div className="quality-hero-overlay" />

        <div className="quality-hero-content right">
          <h1 className="quality-hero-title">
            <span className="green">Quality</span>
          </h1>
        </div>
      </section>
      {/* ================= QUALITY METRICS ================= */}
<section className="quality-metrics-section">
  <div className="quality-metrics-grid">

    {/* LEFT INTRO */}
    <div className="quality-metrics-intro">
      <p>
        As a health company our strongest commitment at Cinfa Group is to the
        <strong> quality, safety and efficacy</strong> of our products.
      </p>
    </div>

    {/* RIGHT METRICS */}
    <div className="quality-metrics-list">

      <div className="quality-metric">
        <div className="metric-main">
          <span className="metric-number green">+30</span>
          <span className="metric-title">quality checks</span>
        </div>

        <div className="metric-text">
          are passed by <strong>every medicine</strong> from Cinfa Group.
          <br />
          <strong>+190,000 tests</strong> per year.
        </div>
      </div>

      <div className="quality-metric">
        <div className="metric-main">
          <span className="metric-number green">+117,000</span>
        </div>

        <div className="metric-text">
          queries per year dealt with by our Customer Care Service under a
          commitment to personalised service and quality.
        </div>
      </div>

      <div className="quality-metric">
        <div className="metric-main">
          <span className="metric-number green">87</span>
          <span className="metric-title">audits</span>
        </div>

        <div className="metric-text">
          <strong>and inspections</strong> conducted on our various suppliers in
          2023.
        </div>
      </div>

      <div className="quality-metric">
        <div className="metric-main">
          <span className="metric-number green">1st</span>
          <span className="metric-title">at pharmacies</span>
        </div>

        <div className="metric-text">
          Cinfa is the <strong>laboratory most highly rated by Spanish
          pharmacies</strong>, according to NPS data (Net Promoter Score) from
          AECOC (Asociación Española de Codificación Comercial).
        </div>
      </div>

    </div>
  </div>
</section>
{/* ================= BIOEQUIVALENTS ================= */}
<section className="bio-image-section">
  <div
    className="bio-image-full"
    style={{ backgroundImage: `url(${bioImage})` }}
  >
    {/* TEXT ON FADED LEFT AREA */}
    <div className="bio-image-overlay-text">
      <h2>
        <span className="green">All our medicines are</span><br />
        <span className="purple">bioequivalents</span>
      </h2>
    </div>
  </div>
</section>
{/* ================= BIOEQUIVALENCE DETAILS ================= */}
<section className="bio-text-section">
  <div className="bio-text-wrapper">
    <p>
      All our medicines are bioequivalents, which guarantees the same
      effectiveness in treatments as the corresponding benchmark medicine.
    </p>

    <p>
      To ensure their quality, each one of our products has to undergo a series
      of strict tests that are conducted at external research centres officially
      approved by the European Medicines Agency (EMA) to clinically verify their
      bioequivalence.
    </p>

    <p>
      At Cinfa, we adapt to each market. Development of each one of our medicines
      therefore complies with the properties of the benchmark medicine in each
      country.
    </p>
  </div>
</section>
{/* ================= QUALITY STANDARDS ================= */}
<section className="quality-standards-section">
  <div className="quality-standards-grid">

    {/* LEFT CONTENT */}
    <div className="quality-standards-content">
      <h2>
        <span className="green">Our standards</span><br />
        <span className="purple">of quality</span>
      </h2>

      <p>
        We hold the international certificates required to market medicines in
        most of the world, enabling us to obtain authorisation from all major
        agencies in this regard.
      </p>
    </div>

    {/* RIGHT LOGOS */}
    <div className="quality-standards-logos">
  <img src={ema} alt="European Medicines Agency" />
  <img src={fda} alt="U.S. Food & Drug Administration" />
  <img src={gmp} alt="GMP" />
  <img src={edqm} alt="EDQM" />
  <img src={gulf} alt="Gulf Health Council" />
  <img src={anvisa} alt="ANVISA" />
  <img src={healthCanada} alt="Health Canada" />
  <img src={tga} alt="TGA Australia" />
  <img src={ministry} alt="Ministry of the Interior" />
  <img src={sahpra} alt="SAHPRA" />
</div>

  </div>

  <p className="quality-standards-note">
    This is just a sample of the authorities and international certifications
    we are guaranteed by.
  </p>
</section>
    </>
  );
};

export default QualityPage;